import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import Hammer from 'react-hammerjs';
import { useSelector } from 'react-redux';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { IDownloadLight } from 'planoplan-ui-kit/core/icons/i-download-light';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { zIndex, Points, textSize, paddingLevel } from '@styles';
import { MAIN_MENU } from '@constants/menu';
import { CustomLink } from '@components/Custom-Link';
import { isHeaderBannerVisible } from '@components/Banners/helpers';

export const MobileMenu = ({
  query = {},
  isOpenMenu = false,
  onCloseMenu,
  menuRef,
  isFixed,
  isDarkMode,
  isTransparent,
}) => {
  const { nextRoute } = query;
  const { showBanners = {}, common = {} } = useSelector((state) => state);
  const { locale } = useSelector((state) => state.settings);
  const isShowHeaderBanner = isHeaderBannerVisible(common.banner, showBanners);
  const mainMenu = MAIN_MENU.filter((i) => i.locale.includes(locale));
  // Ключ нужен что бы заново отрисовать кнопку и убрать навешанные события
  const [key, setKey] = useState('before');

  useEffect(() => {
    setKey('after');
  }, []);

  return (
    <CSSTransition timeout={300} in={isOpenMenu}>
      {(state) => (
        <View className={`slide-left slide-left-${state}`} ref={menuRef}>
          <Hammer onSwipe={onCloseMenu}>
            <Content isFixed={isFixed} isTransparent={isTransparent} isDarkMode={isDarkMode}>
              <Navigation isShowHeaderBanner={isShowHeaderBanner}>
                <List isDarkMode={isDarkMode}>
                  {mainMenu.map(({ href, link, key }) => (
                    <Item key={key} isActive={nextRoute === href}>
                      <CustomLink href={href} link={link && link(locale)} translateKey={key}>
                        {link && link(locale).includes('files') && (
                          <IDownloadLight width="16px" height="16px" fill={Colors.coal} />
                        )}
                      </CustomLink>
                    </Item>
                  ))}
                  <Item isActive={nextRoute === 'download'}>
                    <CustomLink key={key} href={`/download`} translateKey="site.navigation.download"></CustomLink>
                  </Item>
                </List>
              </Navigation>
            </Content>
          </Hammer>
          <Overlay onClick={onCloseMenu} />
        </View>
      )}
    </CSSTransition>
  );
};

const View = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zIndex('mobile-menu')};
  display: flex;
  justify-content: flex-end;

  @media ${Points.laptop} {
    display: none;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  ${Grid.prefix(2)};
  ${Grid.suffix(2)};
  background-color: ${(p) => (p.isDarkMode ? Colors.main_black : Colors.white)};
  padding-top: ${({ isFixed }) => (isFixed ? '62px' : '102px')};
  width: 100%;
  height: 100%;
  border-left: ${(p) => `1px solid ${p.isDarkMode ? Colors.main_dark : Colors.whisper}`};
  overflow-y: auto;
  position: relative;
  z-index: 1;
  -webkit-overflow-scrolling: touch;

  @media ${Points.tablet_portrait} {
    max-width: 320px;
  }
`;

const Navigation = styled.nav`
  margin-top: ${({ isShowHeaderBanner }) => (isShowHeaderBanner ? '60px' : '30px')};
`;

const List = styled.ul`
  ${textSize('p2')};
  ${Mixins.resetList()};
  font-weight: normal;
  color: ${(p) => (p.isDarkMode ? Colors.white : Colors.coal)};
`;

const Item = styled.li`
  ${paddingLevel('bottom', 'dark_cream')};
  text-align: center;

  a {
    ${Mixins.resetLink()};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ isActive }) => isActive && Colors.electric_blue};
  }

  svg {
    display: block;
    margin-left: 7px;
    fill: ${({ isActive }) => isActive && Colors.electric_blue};
  }
`;
